import React, { useMemo } from "react";
import { FiX } from "react-icons/fi";
import { sanitizeBlogHtml } from "../../../utils/blogHtml";
import { createBlogAutoSchema, normalizeSchemaMarkup } from "../../../utils/blogSchema";
import styles from "./ViewBlogModal.module.css";

const renderList = (items = []) =>
  items.length ? (
    <div className={styles.chips}>
      {items.map((item) => (
        <span key={item.id} className={styles.chip}>
          {item.title}
        </span>
      ))}
    </div>
  ) : (
    <p className={styles.empty}>None</p>
  );

export default function ViewBlogModal({ blog, onClose }) {
  const displayedSchema = useMemo(() => {
    if (!blog) return "";
    const customSchema = normalizeSchemaMarkup(blog.schema_markup);
    if (customSchema) return customSchema;
    return JSON.stringify(
      createBlogAutoSchema({
        title: blog.title,
        excerpt: blog.excerpt,
        metaDescription: blog.meta_description,
        image: blog.image || blog.image_url,
        publishedAt: blog.published_at,
        slug: blog.slug,
        canonicalUrl: blog.canonical_url,
      }),
      null,
      2,
    );
  }, [blog]);

  if (!blog) return null;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div>
            <p className={styles.kicker}>Blog Preview</p>
            <h3>{blog.title}</h3>
          </div>
          <button type="button" className={styles.closeBtn} onClick={onClose}>
            <FiX />
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.hero}>
            {blog.image_url ? <img src={blog.image_url} alt={blog.title} /> : <div className={styles.emptyHero}>No image</div>}
          </div>

          <div className={styles.grid}>
            <div>
              <span>Slug</span>
              <strong>{blog.slug}</strong>
            </div>
            <div>
              <span>Status</span>
              <strong>{blog.status_name || "Draft"}</strong>
            </div>
            <div>
              <span>Author</span>
              <strong>{blog.author || blog.created_by_name || "-"}</strong>
            </div>
            <div>
              <span>Canonical URL</span>
              <strong>{blog.canonical_url || "-"}</strong>
            </div>
            <div>
              <span>Meta Title</span>
              <strong>{blog.meta_title || "-"}</strong>
            </div>
            <div className={styles.full}>
              <span>Excerpt</span>
              <p>{blog.excerpt || "-"}</p>
            </div>
            <div className={styles.full}>
              <span>Meta Description</span>
              <p>{blog.meta_description || "-"}</p>
            </div>
            <div className={styles.full}>
              <span>Categories</span>
              {renderList(blog.categories)}
            </div>
            <div className={styles.full}>
              <span>Tags</span>
              {renderList(blog.tags)}
            </div>
            <div className={styles.full}>
              <span>Content</span>
              <div
                className={styles.contentHtml}
                dangerouslySetInnerHTML={{ __html: sanitizeBlogHtml(blog.content) || "<p>-</p>" }}
              />
            </div>
            <div className={styles.full}>
              <span>Schema</span>
              <div className={blog.schema_auto_generated ? styles.schemaBadge : styles.schemaBadgeCustom}>
                {blog.schema_auto_generated ? "Schema auto-generated" : "Custom schema"}
              </div>
              <pre className={styles.code}>{displayedSchema || "-"}</pre>
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.btn} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
